const encrypted = {
  userPass: "userPass",
  credentials: "userCredentials",
  pinCode: "pinCode",
};

export const CryptoProviderFactory = ({
  cryptoJS,
  secretKey,
}: ICryptoProviderFactory) => {
  return {
    encrypt: (value: string) =>
      cryptoJS.AES.encrypt(value, secretKey).toString(),
    decrypt: (value: string) =>
      cryptoJS.AES.decrypt(value, secretKey).toString(cryptoJS.enc.Utf8),
    encrypted,
  };
};

export type ICryptoProvider = ReturnType<typeof CryptoProviderFactory>;
